import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { OperationDetails } from '@modules/operations/Domain/operation.model';

export function canAddConceptValidator(operation: OperationDetails): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const newAmount = control.value * 100; // Convert to cents

    if (newAmount == null || isNaN(newAmount)) {
      return null;
    }
    const existingTotal = operation.items?.reduce((sum, item) => sum + item.amount, 0) || 0;
    const newTotal = existingTotal + newAmount;

    if (newTotal < 0) {
      return { totalNegative: true };
    }

    return null;
  };
}
